import { ReactComponent as Icon } from '../../assets/icons/errorIcon.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" />;
}
